<template>
  <div :class="indentationLevel">
    <h4>
      <span class="label"
            :class="classes">
        {{ parameters.config.text }}
      </span>
    </h4>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'

export default {
  name: 'sheet-add-preview-array',
  props: {
    parameters: {
      type: Object,
      required: true
    }
  },

  computed: {
    indentationLevel: function () {
      assert.notNull(this.parameters.indentation)

      const result = {}
      result[`indentation-${this.indentation}`] = true
      return result
    },

    classes: function () {
      assert.notNull(this.parameters.indentation)

      let result = {
        transparent: this.parameters.config.empty
      }

      let color = 'default'
      switch (this.parameters.indentation) {
        case 0:
          color = 'primary'
          break
        case 1:
          color = 'success'
          break
      }

      result[`label-${color}`] = true
      return result
    }
  }
}
</script>
<style scoped lang="less">
.label{
    display: block;
    text-align: inherit;
    margin-bottom: 0rem;
}

h4{
    margin-bottom: 0rem;
}

.transparent{
    opacity: 0.3;
}

@iterations: 5;
.indent-loop (@i) when (@i > 0) {
    @value: @i * 1.2;
    .indentation-@{i} {
        margin-left: ~"@{value}rem";
    }
    .indent-loop(@i - 1);
}
.indent-loop (@iterations);
</style>
